/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Iade_Iptal_S2_Trial_TermInputs */

const tr_iade_iptal_s2_trial_term = /** @type {(inputs: Iade_Iptal_S2_Trial_TermInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Deneme Süresi (Free Trial):`)
};

const en_iade_iptal_s2_trial_term = /** @type {(inputs: Iade_Iptal_S2_Trial_TermInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Trial Period (Free Trial):`)
};

const de_iade_iptal_s2_trial_term = /** @type {(inputs: Iade_Iptal_S2_Trial_TermInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Testphase (Free Trial):`)
};

const ru_iade_iptal_s2_trial_term = /** @type {(inputs: Iade_Iptal_S2_Trial_TermInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Пробный период (Free Trial):`)
};

/**
* | output |
* | --- |
* | "Trial Period (Free Trial):" |
*
* @param {Iade_Iptal_S2_Trial_TermInputs} inputs
* @param {{ locale?: "tr" | "en" | "de" | "ru" }} options
* @returns {LocalizedString}
*/
export const iade_iptal_s2_trial_term = /** @type {((inputs?: Iade_Iptal_S2_Trial_TermInputs, options?: { locale?: "tr" | "en" | "de" | "ru" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Iade_Iptal_S2_Trial_TermInputs, { locale?: "tr" | "en" | "de" | "ru" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_iade_iptal_s2_trial_term(inputs)
	if (locale === "de") return de_iade_iptal_s2_trial_term(inputs)
	if (locale === "ru") return ru_iade_iptal_s2_trial_term(inputs)
	return tr_iade_iptal_s2_trial_term(inputs)
});